import { Injectable } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';

@Injectable({
  providedIn: 'root'
})
export class ClipboardService {
  dataToCopy: any = { name: 'John Doe', age: 30 };

  constructor(private clipboard: Clipboard) {}

  copyData(data: any) {
    this.dataToCopy = data;
    console.log(this.dataToCopy);
    this.clipboard.copy(JSON.stringify(this.dataToCopy));
  }

  async pasteData() {
    const pastedData = await navigator.clipboard.readText();
    if (pastedData) {
      try {
        const parsedData = JSON.parse(pastedData);
        return parsedData;
      } catch (error) {
        console.error('Error parsing pasted data:', error);
        return null;
      }
    }
  }
}
